module.exports = __webpack_public_path__ + "./fonts/Barlow-Light.otf";